module.exports = __webpack_public_path__ + "static/time_management-baa702675b5f0e52739bf8cd5140c092.svg";